module.exports = __webpack_public_path__ + "img/avata.d7a6025b.svg";